<template>
  <div class="page_container brandIncreasePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>合作品牌管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl" @click="handleGo()">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="keyword"
              placeholder="输入品牌关键字查找→"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示品牌列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.logo" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <h2>品牌名称：</h2>
                    <p>
                      <span>{{
                        item.labelname ? item.labelname : item.labelcont
                      }}</span>
                    </p>
                    <p v-if="item.labelcont_e">
                      <span>{{ item.labelcont_e }}</span>
                    </p>
                    <p v-if="item.labelcont_y">
                      <span>{{ item.labelcont_y }}</span>
                    </p>
                    <p v-if="item.labelcont_m">
                      <span>{{ item.labelcont_m }}</span>
                    </p>
                    <p v-if="item.labelcont_t">
                      <span>{{ item.labelcont_t }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      状态：<span>{{
                        item.labelstate == 1 ? "启用" : "停用"
                      }}</span>
                    </p>
                    <p>
                      所属企业：<span>{{ item.qyname }}</span>
                    </p>
                    <p>
                      添加日期：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      操作人员：<span>{{ item.createman }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleGo(item.id)">
                编辑属性标签→
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加合作品牌"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, getBrandList, encryptstringadd } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "brandList",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      keyword: "",
      qyid: 0,
      qyguid: "",

      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
      this.qyguid = userInfo.qy.qyguid;
    } else {
      this.qyid = 0;
      this.qyguid = 0;
    }
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.init();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 搜索
    handleSearch() {
      this.init();
    },
    // 重置数据
    handleRest() {
      this.keyword = ''
      this.init()
    },
    init() {
      let { keyword, qyguid } = this;
      this.loading = true;
      getBrandList({ keyword, qyguid }).then((res) => {
        let dataNew = res;

        this.dataList = dataNew;
        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },
    handleGo(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }

      if (id) {
        this.encryptstringadd("brandDetail", { id });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("brandDetail", "");
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
      }
    }
  }
}
</style>